module.exports = __webpack_public_path__ + "static/media/icon_medidor.2c939bcd.gif";